export default __webpack_public_path__ + "static/media/reconectme_logo_positivo.49bb51aa.png";